import React from 'react'
import TooltipHLPure from "../tooltipHL/tooltipHL.pure";
import { Grid } from "@material-ui/core";
import "./textAreaHL.css";

/**
 * @typedef {object} CustomProps
 * @property {string} [labelTextArea] - Label text for the textarea
 * @property {string} [valueTextData] - Value of the textarea
 * @property {number} [characterLimit] - Character limit for the textarea
 * @property {boolean} [required] - Whether the textarea is required
 * @property {function} handleChangeTextArea - Function to handle changes in the textarea
 * @property {boolean} [errorInput] - Whether there is an error in the textarea
 * @property {string} [errorTextArea] - Error message to display
 * @property {boolean} [tooltipShow] - Whether to show the tooltip
 * @property {string} [positionTooltip] - Position of the tooltip (top, left, right, bottom)
 * @property {string} [titleTooltip] - Title of the tooltip
 * @property {string} [descriptionTooltip] - Description of the tooltip
 * @property {string} [subContent] - Additional content for the tooltip
 * @property {string} [restContent] - Additional content for the tooltip
 * @property {number} [rowsTextArea] - Number of rows for the textarea
 * @property {boolean} [informationIcon] - Whether to show the information icon
 */

/**
 * @typedef {CustomProps & React.DetailedHTMLProps<React.TextareaHTMLAttributes<HTMLTextAreaElement>, HTMLTextAreaElement>} Props
 */

/**
 * @param {Props} props
 */
const TextAreaHLPure = ({
  labelTextArea,
  valueTextData,
  characterLimit,
  required,
  handleChangeTextArea,
  errorInput,
  errorTextArea,
  tooltipShow,
  positionTooltip,
  titleTooltip,
  descriptionTooltip,
  subContent,
  restContent,
  rowsTextArea,
  informationIcon,
  ...props
}) => {

  //Function, hooks, you can use this to extract the value of the input wherever you are going to use it
  // const [textAreaValue, setTextAreaValue] = useState(valueTextData || "");
  // const [errorInput, setErrorInput] = useState(false);

  // const handleChange = (event) => {
  //   if (event.target.value === undefined || event.target.value === "") {
  //     setErrorInput(true);
  //   } else {
  //     setTextAreaValue(event.target.value);
  //   }
  // };

  const currentLen = characterLimit ? (valueTextData || '').length : 0

  const onLimitedTextChange = (event) => {
    handleChangeTextArea(event);
  }

  return (
    <div
      item
      xs={12}
      lg={12}
      md={12}
      sm={12}
      className={"textAreaHLPure-container"}
    >
      <Grid item className={"textAreaHLPure-container-textFlex"}>
        <label className="textAreaHLPure-label" name="label">
          {labelTextArea} {required ? "*" : ""}
        </label>
        {tooltipShow ? (
          <TooltipHLPure
            positionTooltip={positionTooltip}
            titleTooltip={titleTooltip}
            descriptionTooltip={descriptionTooltip}
            subContent={subContent}
            restContent={restContent}
            informationIcon={informationIcon}
          />
        ) : (
          ""
        )}
      </Grid>
      <textarea
        {...props}
        rows={rowsTextArea}
        className="textAreaHLPure-input"
        id="valueTextData"
        name="valueTextData"
        value={valueTextData || ""}
        onChange={characterLimit ? onLimitedTextChange : handleChangeTextArea}
        component={props.validateInput}
        maxLength={characterLimit}
      />
      <div className="inputHLPure-hints">
        {errorInput && (
          <span className="hint-message-error">{errorTextArea}</span>
        )}
        {characterLimit && (
          <span className='character-limit'>{currentLen}/{characterLimit}</span>
        )}
      </div>
    </div>
  );
};

export { TextAreaHLPure as default };
